import { QueryState } from "../core/models/query.model";
import { createTokenQueryServiceInstance } from "../core/services/query.service";
import { SignalStoreConfig } from "../shared/functions/store.functions";

export const COORDINATE_ENDPOINT = 'coordinate';
export const COORDINATE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(COORDINATE_ENDPOINT);

export const coordinateStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: [],
    sort: {
      field: 'id',
      direction: 'asc'
    }
  }
}
